import { ExtPersonDocument, PersonDocument } from 'services/SwaggerApi';

export const isPersonDocument = (document: PersonDocument | ExtPersonDocument): document is PersonDocument => {
    return (document as PersonDocument).country !== undefined;
};
